(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/place-bet/place-bet-selfservice.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/place-bet/place-bet-selfservice.js');
"use strict";


const {
  createSelfServicePaymentFlow
} = svs.components.wagerPaymentFlow.selfServiceFlow;

async function placeBetSelfService(_ref) {
  let {
    drawData,
    productId,
    unlockPaymentFlow,
    closeCallback,
    isPixMix
  } = _ref;
  if (!drawData) {
    unlockPaymentFlow();
    return;
  }
  let regCloseTime;
  let subProductId;
  if (drawData) {
    var _drawData$regCloseTim;
    regCloseTime = (_drawData$regCloseTim = drawData.regCloseTime) !== null && _drawData$regCloseTim !== void 0 ? _drawData$regCloseTim : drawData.closeTime;
    subProductId = drawData.subProductId;
  }
  const pixHandler = svs.components.sport.pixHandler.getPixHandler({
    isPixMix
  });
  const wager = pixHandler.createPixWager({
    productId,
    subProductId
  });
  const wagerCount = await createSelfServicePaymentFlow({
    wagers: [wager],
    regCloseTimes: [regCloseTime]
  });
  if (wagerCount > 0) {
    pixHandler.fetch({
      productId,
      shouldGenerateNewPix: true
    });
    unlockPaymentFlow();
    if (closeCallback) {
      closeCallback();
    }
  }
}
setGlobal('svs.components.sport.quickplayModal.placeBet.placeBetSelfService', placeBetSelfService);

 })(window);